import { proxy, subscribe } from 'valtio';

export enum BillOfMaterialsView {
    GROUPED = 'grouped',
    UNGROUPED = 'ungrouped',
}

const billOfMaterialsState = proxy<{
    currentView: BillOfMaterialsView;
    openAllGroups: boolean;
    showAddFieldModal: boolean;
    saveState: 'idle' | 'saving' | 'saved';
}>({
    currentView: BillOfMaterialsView.UNGROUPED,
    openAllGroups: true,
    showAddFieldModal: false,
    saveState: 'idle',
});

let savedTimer: ReturnType<typeof setTimeout> | null = null;

subscribe(billOfMaterialsState, () => {
    if (billOfMaterialsState.saveState !== 'saved') return;
    if (savedTimer) clearTimeout(savedTimer);
    savedTimer = setTimeout(() => (billOfMaterialsState.saveState = 'idle'), 2000);
});

export { billOfMaterialsState };
